//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Toast } from 'vant';

export default {

    components: {

    },
    data () {
        return {
            showMenu:false,
            filterAll:true,
            fliterPrice:false,
            popFilter:false,
            hotSearch:[],
            saasList:[],
            typeList:[],
            hotSearch:"",
            historyWord:[],
            newHistoryWord:[],
            storage:{},
            sqlList:[],
            BuList:[{ name:"全部"},{
            name:"线上部署"},{ name:"线下部署"}],
            model:{dbTypes:0,timeOrder:2,priceOrder:0,saaSApp:1,recommend:1,pageSize:0},
            recommendNumber:0,
            changeCkd:0,
            changeB:0,
            changeSql:0,
            idNumber:0,
            Bstatus:0,
            changePage:false,
            loading: false,
            finished: false,
            listPhoto:[],
            showCot:0
        }
    },
      created(){
        this.getTypeList();
        this.getList();
        this.getsqlList();
        this.getHotSearch();
        this.getListPhoto();
    },
    methods: {
        goBack(){
            this.$router.push({
                path : '/mall/index',
                query : {}
           })
        },
        clearHistory(){
            localStorage.clear();
            // this.$router.go(0);
            this.getHistorySearch();
            Toast('删除历史数据成功');
            
        },
        openDetail(item){
            if(item.goodsPriceType == 3){
            this.$router.push({path:'detail',query:{'appId':item.appId,'status':1}});
            // window.location.href="http://190.160.1.117:7080/m/mall/app/detail.html?appId="+item.appId;
            } 
            if(item.goodsPriceType == 4){
                this.$router.push({path:'detail1',query:{'goodsId':item.goodsId,'status':1}});
                // window.location.href="http://190.160.1.117:7080/m/mall/app/detail1.html?goodsId="+item.goodsId;
            }
        },
        onLoad() {
            // 异步更新数据
            setTimeout(() => {
                this.model.pageSize=this.model.pageSize+10;
                this.$http.post(this.global.httpUrl + '/rest/v1/m/mapp/getGoodsList',this.model,{emulateJSON:true}).then(function(res){
                    if(res.body.success)
                    { 
                        this.saasList = res.body.rows;
                        // 加载状态结束
                        this.loading = false;
                        // 数据全部加载完成
                        if (this.saasList.length >= res.body.total) {
                            this.finished = true;
                        }   
                    }    
                },function(res){
                    }); 
            }, 500);
        },
        getSearchList(item){
            if(item.historyWord!= "undefined"&& item.historyWord!= null){
                this.model.goodsName=item.historyWord;
            }
            if(item.hotWordStr!= "undefined"&& item.hotWordStr!= null){
                this.model.goodsName=item.hotWordStr;
            }
            this.$set(this.model,'recommend',0);
            this.getList();
            this.changePage=false;
        },
        changeStatu(){
            this.changePage = true;
            this.getHistorySearch();
        },
        getList(){
                this.$http.post(this.global.httpUrl + '/rest/v1/m/mapp/getGoodsList',this.model,{emulateJSON:true}).then(function(res){
                if(res.body.success)
                { 
                    this.saasList = res.body.rows;
                    if(this.saasList.length>0){
                        this.showCot=1
                    }else{
                        this.showCot=-1
                    }
                    this.recommendNumber=res.body.recommendNumber;
                }    
            },function(res){
            });
        },
        getHotSearch(){
            this.$http.post(this.global.httpUrl + '/rest/v1/m/mall/mpass/getHotWords',this.model,{emulateJSON:true}).then(function(res){
                if(res.body.success)
                { 
                    this.hotSearch= res.body.rows;
                }    
            },function(res){
            });
        },
        getSqlAndType(){
            this.$set(this.model,'recommend',0);
            this.getList();
            this.toggleFilter(3);
        },
        getListPhoto(){
            this.$http.post(this.global.httpUrl + '/rest/v1/m/mall/mapp/getDevStaticPageBannerList',this.model,{emulateJSON:true}).then(function(res){
                if(res.body.success)
                { 
                    let listPhoto = res.body.rows;
                
                    for(let i=0;i<listPhoto.length;i++){
                        if(listPhoto[i].devPageId==6){
                            this.listPhoto.push(listPhoto[i]);
                        }
                    }
                }    
            },function(res){
            });
        },
        getTypeList(){
                this.$http.post(this.global.httpUrl + '/rest/v1/m/mall/mdemand/getAppTypes',this.model,{emulateJSON:true}).then(function(res){
                    if(res.body.success)
                    { 
                        this.typeList = res.body.data;
                    }    
                },function(res){
            });
        },
        getHistorySearch(){
            this.newHistoryWord=[];
            var that = this
            this.storage=window.localStorage;
            var tmpe=[];
            for(var i=1;i<11;i++){
                if( this.storage.getItem('search_'+i)!= null){
                    this.newHistoryWord.push({"historyWord":this.storage.getItem('search_'+i)});
                }else{
                    return;
                }
            }
        },
         getsqlList(){
            this.$http.post(this.global.httpUrl + '/rest/v1/m/mall/mpass/getDbTypes',this.model,{emulateJSON:true}).then(function(res){
                if(res.body.success)
                { 
                    this.sqlList = res.body.dbTypes;
                }    
            },function(res){
            });
        },
        goSearch(){
            this.$router.push('/m/app/saas/search')
        },
        getTypeId(item,index){
            this.changeCkd =index;
            if(item.appTypeId !=undefined){
            this.model.types= item.appTypeId;
            }else{
                this.model.types=null;
            }
        },
        getSqlId(item,index){
            this.changeSql =index;
            if(item.dbType !=undefined){
            this.model.dbTypes= item.dbType;
            }else{
                 this.model.dbTypes=null;
            }
        },
        getSearch(){
            this.$set(this.model,'recommend',0);
            if(this.model.goodsName!=null && this.model.goodsName.trim()!=""){
                //第一次的时候，设置1
                if(localStorage.getItem("index")==null){
                    localStorage.setItem("index",1);
                    localStorage.setItem("search_1",this.model.goodsName); 
                }else{
                    var index=localStorage.getItem("index");
                    //如果到10了重置为1
                    if(index==10){
                        index=1
                    }else{
                        index++;
                    }
                    var searchMode="";
                    for(var i=1;i<=localStorage.getItem("index");i++){
                        if(localStorage.getItem("search_"+i)==this.model.goodsName){
                        break;
                        }
                        if(i==(localStorage.getItem("index"))){
                            localStorage.setItem("index",index);
                            localStorage.setItem("search_"+index,this.model.goodsName); 
                        }
                    }
                }    
                this.index++;
                this.storage.setItem(this.index, this.model.goodsName);
            }
            this.getList();
            this.changePage=false;
        },
        getArrangeType(i){
            this.changeB = i;
            this.$set(this.model,'arrangeType',i);
        },
        toggleMenu(){
            this.showMenu = !this.showMenu
        },
        toggleFilter(e){
            if(e==1){
                this.fliterPrice=false;
                this.filterAll=true
                if(this.idNumber ==0 || this.idNumber== 1){
                    this.idNumber=2;
                    this.$set(this.model,'timeOrder',2);
                }else{
                    this.idNumber=1;
                    //auth:qy this.$set(this.model,'timeOrder',1);
                    this.$set(this.model,'timeOrder',2);
                }
                 this.$set(this.model,'priceOrder',0);
                  this.getList();
              
            }
            if(e==2){
                this.fliterPrice=true
                this.filterAll = false;
                if(this.priceNumber ==0 || this.priceNumber== 1){
                    this.priceNumber=2;
                    this.$set(this.model,'priceOrder',2);
                }else{
                    this.priceNumber=1;
                    this.$set(this.model,'priceOrder',1);
                }
                this.$set(this.model,'timeOrder',0);
                this.getList();
            }
            if(e==3){
                this.popFilter=!this.popFilter
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/mall/app/list.vue